import { Component, type ErrorInfo, type ReactNode } from 'react';
import { ServerError } from '../../pages/public/ServerError';
import { PublicHeader } from '../../layouts/PublicHeader';
import { PublicFooter } from '../../layouts/PublicFooter';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null,
    };

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('[ErrorBoundary] Uncaught application error:', error, errorInfo);
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen flex-col bg-background text-foreground font-sans relative overflow-x-clip">
                    <PublicHeader />
                    <main className="flex-1">
                        <ServerError
                            error={this.state.error}
                            resetError={() => this.setState({ hasError: false, error: null })}
                        />
                    </main>
                    <PublicFooter />
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
